<template>
    <v-container>
        <p class="font-weight-black display-4">URL Not Found</p>
        <v-btn outlined v-on:click="returnHome">Return</v-btn>
    </v-container>
</template>

<script>
    export default {
        name: "NotFound",
        methods: {
            returnHome: function () {
                console.log(window.location.origin);
                window.location.replace(window.location.origin);
            }
        }
    }
</script>

<style scoped>

</style>